module.exports = ".exHeader {\n  height: 60px;\n}\n\nimg {\n  width: 60%;\n}\n"